import {
  RECEIVE_MENUS,
  LOADING_MENU,
  MENU_ERROR,
  PUBLISH_MENU_SUCCESS,
  FINISH_PUBLISH_MENU,
  FINISH_DELETE_MENU,
  DELETE_MENU_SUCCESS,
  CREATE_MENU_SUCCESS,
  CREATE_MENU_FAILURE,
  FINISH_CREATE_MENU,
  EDIT_MENU_SUCCESS,
  EDIT_MENU_FAILURE,
  FINISH_EDIT_MENU,
  DELETE_MENU_FAILURE,
  CLEAR_MENU_ERRORS,
} from './actions';

const initialState = {
  menus: [],
  menu: {},
  isLoading: false,
  isPublishMenuFinished: false,
  isDeleteMenuFinished: false,
  isCreateMenuFinished: false,
  isEditMenuFinished: false,
  error: {},
  deleteError: false,
};

export default function menu(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_MENUS:
      return {
        ...state,
        menus: action.payload,
        isLoading: false,
      };
    case LOADING_MENU:
      return {
        ...state,
        isLoading: true,
      };
    case MENU_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case PUBLISH_MENU_SUCCESS:
      return {
        ...state,
        isPublishMenuFinished: true,
        isLoading: false,
        menu: {},
      };
    case FINISH_PUBLISH_MENU:
      return {
        ...state,
        isPublishMenuFinished: false,
      };
    case DELETE_MENU_SUCCESS:
      return {
        ...state,
        isDeleteMenuFinished: true,
        isLoading: false,
      };
    case DELETE_MENU_FAILURE:
      return {
        ...state,
        isDeleteMenuFinished: false,
        isLoading: false,
        deleteError: true,
      };
    case FINISH_DELETE_MENU:
      return {
        ...state,
        isDeleteMenuFinished: false,
      };
    case CREATE_MENU_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isCreateMenuFinished: true,
        menu: action.payload,
        error: false,
      };
    case CREATE_MENU_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: {
          ...action.error,
        },
      };
    case FINISH_CREATE_MENU:
      return {
        ...state,
        isCreateMenuFinished: false,
        error: false,
      };
    case EDIT_MENU_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isEditMenuFinished: true,
        menu: action.payload,
        error: false,
      };
    case EDIT_MENU_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: {
          ...action.error,
        },
      };
    case FINISH_EDIT_MENU:
      return {
        ...state,
        isEditMenuFinished: false,
        error: false,
      };
    case CLEAR_MENU_ERRORS:
      return {
        ...state,
        error: false,
        deleteError: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/menu/reducer.js